export default {
  pt: {
    title: "Análise em andamento",
    message: "O modelo da sua bicicleta está em análise personalizada pelos nossos consultores.",
    description: "Estamos revisando os detalhes para garantir a melhor oferta de seguro para você. Fique tranquilo, avisaremos assim que estiver pronto!",
    supportButton: "Falar com suporte"
  },
  en: {
    title: "Analysis in progress",
    message: "Your bike model is undergoing a personalized analysis by our consultants.",
    description: "We are reviewing the details to ensure the best insurance offer for you. Rest assured, we will notify you as soon as it's ready!",
    supportButton: "Contact support"
  }
}
